import { Route, Switch, Redirect } from 'react-router-dom';

import Header from './Header/Header';
import Gdpr from './Gdpr/Gdpr';
import FeedbackList from './Feedback/FeedbackContainer';
import Bookmarks from './Bookmark/Bookmarks';
import Menu from './Menu/Menu';
import NotFoundPage from './NotFoundPage';
import Unauthorized from './Unauthorized';
import PropTypes from 'prop-types';
import React from 'react';
import { hot } from 'react-hot-loader';
import { IntlProvider } from 'react-intl';
import messages_cs from '../localizations/cs.json';
import messages_en from '../localizations/en.json';
import Authenticate from './Authenticate/AuthenticateContainer';
import config from 'react-global-configuration';
import moment from 'moment';
import jwt_decode from 'jwt-decode';
// import Cookies from 'universal-cookie';

// This is a class-based component because the current
// version of hot reloading won't hot reload a stateless
// component at the top-level.

const messages = {
  cs: messages_cs,
  en: messages_en,
};

const getLanguage = () => {
  let language = localStorage.getItem('LANGUAGE');
  if (!language) {
    language = 'en';
    localStorage.setItem('LANGUAGE', language);
  }
  return language;
};

class App extends React.Component {
  render() {
    const token = localStorage.getItem('QUSER');
    const language = getLanguage();

    return (
      <IntlProvider
        messages={messages[language]}
        locale={language}
        defaultLocale="en"
      >
        <Header />
        <Menu />
        <Gdpr />
        <Switch>
          <Redirect exact from="/" to="/feedback?bookmark=main" />
          <PrivateRoute
            path="/feedback"
            component={FeedbackList}
            validate={this.validateUser}
            allowedRoles={config.get('allRoles')}
          />
          <Route path="/authenticate" component={Authenticate} />
          {/* <PrivateRoute path="/bookmarks" component={Bookmarks} validate={this.validateUser} allowedRoles={['ROLE_CARFEEDBACK_ADMINS']}/> */}
          <Route path="/unauthorized" component={Unauthorized} />
          <Route component={NotFoundPage} />
        </Switch>
      </IntlProvider>
    );
  }

  validateUser = (allowedRoles) => {
    const token = localStorage.getItem('QUSER');
    if (!token) {
      console.warn('MISSING TOKEN');
      window.location.href = config.get('login');
      return true;
    }

    try {
      const decoded = jwt_decode(token);
      let expire = decoded.exp;
      expire = moment.unix(expire);
      if (expire.isBefore()) {
        console.warn('EXPIRED TOKEN');
        window.location.href = config.get('login');
        return true;
      }
      const userRole = decoded.aud;
      if (!allowedRoles.includes(userRole)) {
        return false;
      }
    } catch (err) {
      console.warn('INVALID TOKEN', err);
      window.location.href = config.get('login');
      return true;
    }
    return true;
  };
}

const PrivateRoute = ({
  component: Component,
  validate,
  allowedRoles,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) =>
      validate(allowedRoles) ? (
        <Component {...props} />
      ) : (
        <Redirect to="/unauthorized" />
      )
    }
  />
);

PrivateRoute.propTypes = {
  component: PropTypes.object,
  validate: PropTypes.func,
  allowedRoles: PropTypes.array,
};

App.propTypes = {
  children: PropTypes.element,
  history: PropTypes.object,
};

export default hot(module)(App);
